import { Link } from "react-router-dom";
import { usePageSeo } from "@/hooks/usePageSeo";
import { useLang } from "@/context/LanguageContext";
import { PageHero } from "@/components/common/PageHero";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Button } from "@/components/ui/button";
import { IMAGES } from "@/lib/site";
import { Handshake, Megaphone, GraduationCap, Newspaper, Users, Building2 } from "lucide-react";

const ICONS = [Handshake, Megaphone, GraduationCap, Newspaper, Users, Building2];

export default function Partners() {
  const { L } = useLang();
  const P = L.pages.partners;
  usePageSeo("partners");
  return (
    <>
      <PageHero
        overline={P.overline}
        title={P.title}
        description={P.desc}
        breadcrumbs={[{ label: L.common.home, to: "/" }, { label: L.nav.partners }]}
      >
        <Button asChild size="lg" className="mt-8 bg-finblue hover:bg-finblueDark" data-testid="partners-cta"><Link to="/become-a-partner">{L.common.becomePartner}</Link></Button>
      </PageHero>

      <section className="py-20 lg:py-28">
        <div className="container-tight">
          <SectionHeading overline={P.whoOverline} title={P.whoT} />
          <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {P.segments.map((s, i) => {
              const Icon = ICONS[i];
              return (
                <div key={i} className="rounded-xl border border-hair bg-white p-6 shadow-sm transition-all hover:-translate-y-1 hover:shadow-md">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-lg bg-navy text-gold"><Icon className="h-6 w-6" strokeWidth={1.5} /></span>
                  <h3 className="mt-5 font-heading text-lg font-semibold text-ink">{s[0]}</h3>
                  <p className="mt-2 text-sm text-subtle">{s[1]}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden bg-navy2 py-20 lg:py-28">
        <div className="absolute inset-0 grid-lines opacity-50" />
        <div className="container-tight relative grid items-center gap-12 lg:grid-cols-2">
          <img src={IMAGES.partnership} alt="Partnership" className="rounded-2xl border border-white/10 object-cover shadow-2xl" />
          <div>
            <p className="overline mb-3 text-gold">{L.partnership.overline}</p>
            <h2 className="font-heading text-3xl font-bold text-white">{L.partnership.title}</h2>
            <ul className="mt-6 grid grid-cols-1 gap-3 text-sm text-slate-300 sm:grid-cols-2">
              {L.partnership.benefits.map((b) => <li key={b} className="flex items-start gap-2"><span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-gold" />{b}</li>)}
            </ul>
            <Button asChild size="lg" className="mt-8 bg-finblue hover:bg-finblueDark"><Link to="/become-a-partner">{L.common.apply}</Link></Button>
          </div>
        </div>
      </section>
    </>
  );
}
